"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.megaMenuSearchPopupReducer = void 0;
var LayoutState_init_1 = require("@/pages/common/states/LayoutState.init");
var MegaMenuSearchAction_1 = require("@/pages/common/actions/MegaMenuSearchAction");
var typesafe_actions_1 = require("typesafe-actions");
var megaMenuSearchPopupReducer = function (state, action) {
    if (state === void 0) { state = LayoutState_init_1.defaultLayoutState; }
    switch (action.type) {
        case typesafe_actions_1.getType(MegaMenuSearchAction_1.default.setActive): {
            return __assign(__assign({}, state), { megamenusearch: __assign(__assign({}, state.megamenusearch), { active: action.payload }) });
        }
        case typesafe_actions_1.getType(MegaMenuSearchAction_1.default.setType): {
            return __assign(__assign({}, state), { megamenusearch: __assign(__assign({}, state.megamenusearch), { type: action.payload, suggestions: [], suggestionLoading: false }) });
        }
        case typesafe_actions_1.getType(MegaMenuSearchAction_1.default.setInput): {
            return __assign(__assign({}, state), { megamenusearch: __assign(__assign({}, state.megamenusearch), { keyword: action.payload }) });
        }
        case typesafe_actions_1.getType(MegaMenuSearchAction_1.default.setSuggestionGroups): {
            return __assign(__assign({}, state), { megamenusearch: __assign(__assign({}, state.megamenusearch), { suggestionGroups: action.payload }) });
        }
        case typesafe_actions_1.getType(MegaMenuSearchAction_1.default.setSuggestionGroupRowIndex): {
            return __assign(__assign({}, state), { megamenusearch: __assign(__assign({}, state.megamenusearch), { suggestionGroupIndex: action.payload.groupIndex, suggestionRowIndex: action.payload.rowIndex }) });
        }
        case typesafe_actions_1.getType(MegaMenuSearchAction_1.default.setLoading): {
            return __assign(__assign({}, state), { megamenusearch: __assign(__assign({}, state.megamenusearch), { suggestionLoading: action.payload }) });
        }
        case typesafe_actions_1.getType(MegaMenuSearchAction_1.default.setFullscreenLoading): {
            return __assign(__assign({}, state), { megamenusearch: __assign(__assign({}, state.megamenusearch), { fullscreenloading: action.payload }) });
        }
    }
    return state;
};
exports.megaMenuSearchPopupReducer = megaMenuSearchPopupReducer;
